const getOffsetQueryValue = (queryParams) => {
  const offsetValue = queryParams.offset;
  if (offsetValue && !Number.isNaN(Number(offsetValue))) {
    return Number(offsetValue);
  }
  return 0;
};
export {
  getOffsetQueryValue
};
